import React from 'react'
import { Outlet } from 'react-router-dom'
import init from '@vero/ui-core-browser/init.jsx'
import './app.css'
import config from './config.js'
import ErrorPage from './pages/error.jsx'
import AuthPage from './pages/auth.jsx'
import ChangePassword from './pages/change-password.jsx'
import SelectCompany from './pages/select-company.jsx'
import Login from './widgets/login.jsx'
import CreatePassword from './widgets/create-password.jsx'
import ResetPassword from './widgets/reset-password.jsx'
import ZendeskMessagingBoot from './zendesk-messaging-boot.jsx'

function AppShell () {
  return (
    <>
      <ZendeskMessagingBoot />
      <Outlet />
    </>
  )
}

init(
  [
    {
      element: <AppShell />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: '/',
          errorElement: <ErrorPage />
        },
        {
          path: '/auth?/login',
          element: <AuthPage title='sign in' Widget={Login} />,
          errorElement: <ErrorPage />
        },
        {
          path: '/auth/create-password',
          element: <AuthPage title='create password' Widget={CreatePassword} />,
          errorElement: <ErrorPage />
        },
        {
          path: '/auth?/password-recovery',
          element: <AuthPage title='reset password' Widget={ResetPassword} />,
          errorElement: <ErrorPage />
        },
        {
          path: '/auth/reset-password',
          element: <AuthPage title='reset password' Widget={ResetPassword} />,
          errorElement: <ErrorPage />
        },
        {
          path: '/auth/change-password',
          element: <ChangePassword title='change password' />,
          errorElement: <ErrorPage />
        },
        {
          path: '/auth?/select-company',
          element: <SelectCompany title='select company' />,
          errorElement: <ErrorPage />
        }
      ]
    }
  ],
  config
)
